export default "__VITE_ASSET__BPT0luRw__"